import { useState } from "react";

// pages for Wizard
import WizardCalibrateScan from "./CalibrationFlow/WizardCalibrateScan";
import WizardCalibrateSuccess from "./CalibrationFlow/WizardCalibrateSuccess";
import WizardCalibrateFail from "./CalibrationFlow/WizardCalibrateFail";

const WizardCalibrate = ({
  isCalibrate,
  setIsCalibrate,
  changeStep,
  setShowToast,
}) => {
  // step tracker, this state is used to show corresponding wizard page
  const [calibrationStep, setCalibrationStep] = useState(0);

  const wizardPages = {
    WizardCalibrateScan: 0,
    WizardCalibrateFail: 1,
  };

  // function to update the step
  // this will be passed into each Wizard Component
  // and will appropriately udpate the current step
  const changeCalibrationStep = (value) => {
    console.log(`step: ${calibrationStep} ${value}`);

    if (value === "success") {
      setCalibrationStep(wizardPages.WizardCalibrateScan);
      changeStep("continue");
      setIsCalibrate(false);
      setShowToast(true);
    }
    if (value === "fail" && calibrationStep < Object.keys(wizardPages).length) {
      console.log(
        "Changing to fail page (" + wizardPages.WizardCalibrateFail + ")..."
      );
      setCalibrationStep(wizardPages.WizardCalibrateFail);
    }

    if (value === "return") {
      setCalibrationStep(wizardPages.WizardCalibrateScan); // In case user tries to calibrate another
      changeStep("return");
      setIsCalibrate(false);
    }

    if (value === "rescan") {
      setCalibrationStep(wizardPages.WizardCalibrateScan);
    }
  };

  if (!isCalibrate) {
    return null;
  }
  return (
    <div className='container'>
      <div className=''>
        <WizardCalibrateScan
          step={calibrationStep}
          changeStep={changeCalibrationStep}
          pageID={wizardPages.WizardCalibrateScan}
        />
        <WizardCalibrateFail
          step={calibrationStep}
          changeStep={changeCalibrationStep}
          pageID={wizardPages.WizardCalibrateFail}
        />
        <WizardCalibrateSuccess
          step={calibrationStep}
          setIsCalibrate={setIsCalibrate}
          changeStep={changeCalibrationStep}
          pageID={wizardPages.WizardCalibrateSuccess}
        />
      </div>
    </div>
  );
};

export default WizardCalibrate;
